<template lang="pug">
#preencher-contrato-originacao(v-loading='loading')
    BaseHeader(
        :titulo='$t("mensagens.subEmpresaGestao.preenchercontratooriginacao.titulo")',
        :exibeBotao='false',
        :voltarPara='true'
    )

    .view-container.margen-bottom-pages
        .bloco-dados-contrato-originacao
            VizualizarDadosAR(
                :dados='contratoOriginacao',
                :carregandoDadosGerais='carregandoDadosGerais'
            )

        .bloco-inserir-dados-contrato-originacao
            GestaoElegibilidade(
                @contratoInserido='atualizarTabela',
                :volumeDisponivelContrato='volumeDisponivelContrato',
                :dados='contratoOriginacao',
                @atualizarListaPosInserir='atualizarAposInserir',
                :isRastreabilidadeOffline='isRastreabilidadeOffline'
            )

        ModalAnaliseElegibilidade(
            :show='ativarModalAnaliseElegibilidade',
            :dados='dadosAnaliseElegibilidade',
            @handleCloseModalAnaliseElegibidade='ativarModalAnaliseElegibilidade = false'
        )

        .bloco-infor
            el-alert(
                v-if='mensagemValidacaoConcluir.length > 0',
                :title='$t("mensagens.subEmpresaGestao.visualizarRastreabilidadeSubEmpresaContrato.quadroAvisos")',
                type='warning',
                show-icon,
                :closable='false'
            )
                ul
                    li(v-for='mensagem in mensagemValidacaoConcluir') {{ mensagem }}

        .bloco-dados-contrato-originacao
            TabelaTerritorioInseridosNoContratoAr(
                ref='tabelaTerritorioAr',
                :btnRecarregar='true',
                :territoriosNaoEnviados='dataTerritoriosNaoEnviados',
                :removendo='removendoTerritoriosCertificados',
                :volumeDisponivelContrato='volumeDisponivelContrato',
                :carregando='loadingTabelaCarsInseridosNoContrato',
                :paginacao='paginacao',
                :idSucursal='$route.params.idSucursal || $route.query.idSucursal || 0',
                @removerTerritorioLote='removerTerritorioLote',
                @territorioRemovido='atualizarTabela',
                @removerTerritorioBlocoInserirContratoUploadPlanilha='removerTerritorioBlocoInserirContratoUploadPlanilha',
                @mudarPagina='mudarPagina',
                @ordenarTabela='ordenarTabela',
                @realizarElegibilidadePY='realizarElegibilidadePY',
                @reprocessarElegibilidadePY='reprocessarElegibilidadePY',
                @visualizarAnaliseElegibilidade='visualizarAnaliseElegibilidadeAR',
                @atualizarTabela='atualizarTabela'
            )

        footer
            .botao-certificacao__remover
                el-button(
                    v-if='removendoTerritoriosCertificados',
                    @click.native='removendoTerritoriosCertificados = false'
                ) {{ $t('mensagens.subEmpresaGestao.tabelaCarsInseridosNoContrato.cancelar') }}

                el-button(
                    v-if='!removendoTerritoriosCertificados',
                    type='danger',
                    icon='el-icon-delete',
                    @click.native='removendoTerritoriosCertificados = true'
                ) {{ $t('mensagens.subEmpresaGestao.tabelaCarsInseridosNoContrato.remover') }}

                el-button(
                    v-else,
                    type='danger',
                    icon='el-icon-delete',
                    @click.native='removerTerritorio'
                ) {{ $t('mensagens.subEmpresaGestao.tabelaCarsInseridosNoContrato.confirmar') }}

            .botao-territorio__enviar-para-analise
                el-button#adicionar-analise(
                    v-if='!usuarioLogado.isBrasil',
                    icon='lyra-icon lyra-grafico-3',
                    :loading='loadingRealizarAnaliseElegibilidade',
                    plain,
                    slot='reference',
                    @click.native='realizarAnaliseElegibilidade'
                ) {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.realizarAnaliseElegibilidade') }}

                el-button#adicionar-analise(
                    icon='el-icon-view',
                    plain,
                    slot='reference',
                    @click.native='visualizarContratoSucursal'
                ) {{ $t('mensagens.subEmpresaGestao.preenchercontratooriginacao.visualizar') }}
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import VizualizarDadosAR from '@/components/contratosOriginacao/SubEmpresaBlocoDadosVisualizarContratoOriginacaoAR.vue';
import BlocoInserirDadosManual from '@/components/contratosOriginacao/SubEmpresaBlocoInserirDadosContratoManualmente.vue';
import GestaoElegibilidade from '@/components/contratosOriginacao/SubEmpresaGestaoElegibilidadeAR.vue';
import BlocoInserirDadosPlanilha from '@/components/contratosOriginacao/SubEmpresaBlocoInserirDadosContratoViaPlanilha.vue';
import TabelaCarsInseridosNoContrato from '@/components/contratosOriginacao/TabelaCarsInseridosNoContrato.vue';
import TabelaTerritorioInseridosNoContratoAr from '@/components/contratosOriginacao/TabelaTerritorioInseridosNoContratoAr.vue';
import ModalAnaliseElegibilidade from '@/components/contratosOriginacao/ModalAnaliseElegibilidadeResumoAr.vue';
import SubEmpresaBlocoInserirDadosContratoUploadPlanilha from '@/components/contratosOriginacao/SubEmpresaBlocoInserirDadosContratoUploadPlanilha.vue';

import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import RaioPermitidoPorEstadoRastreabilidadeService from '@/services/RaioPermitidoPorEstadoRastreabilidadeService';
import EstadoService from '@/services/EstadoService';

import { connect, subscribe, disconnect } from '@/utils/websocket';
import { mascaraRenspa } from '@/utils/masks/renspa.js';
import { mapGetters } from 'vuex';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';
import SucursaleService from '@/services/SucursaleService';

export default {
    name: 'PreencherContratoOriginacao',
    components: {
        BaseHeader,
        VizualizarDadosAR,
        BlocoInserirDadosManual,
        GestaoElegibilidade,
        BlocoInserirDadosPlanilha,
        TabelaCarsInseridosNoContrato,
        TabelaTerritorioInseridosNoContratoAr,
        ModalAnaliseElegibilidade,
        SubEmpresaBlocoInserirDadosContratoUploadPlanilha
    },
    data() {
        return {
            loading: false,
            contratoOriginacao: {},
            dataTerritoriosNaoEnviados: [],
            territoriosSelecionados: [],
            removendoTerritoriosCertificados: false,
            volumeDisponivelContrato: 0,
            loadingTabelaCarsInseridosNoContrato: false,
            raiosPermitidosPorEstado: [],
            paginacao: {
                pagina: 0,
                total: null,
                itensPorPagina: 10
            },
            ativarModalAnaliseElegibilidade: false,
            dadosAnaliseElegibilidade: {},
            saldoTerritorioAr: {},
            dadosCalculoRaioAR: {},
            loadingResumo: {
                loadingDiagnostico: false,
                loadingRaio: false,
                loadingSaldo: false,
                analiseElegibilidade: false
            },
            loadingRealizarAnaliseElegibilidade: false,
            carregandoDadosGerais: false,
            isRastreabilidadeOffline: false,
            ambientes: AmbientesEmpresas,
            dadosEdicaoVolume: {},
            statusSubEmpresaCodigo: '',
            mensagemValidacaoConcluir: []
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado', 'isAlvorada']),
        primeiroRuc() {
            const ruc = this.contratoOriginacao?.ruc;
            return Array.isArray(ruc) && ruc.length > 0 ? ruc[0] : '';
        }
    },

    beforeDestroy() {
        disconnect();
    },

    mounted() {
        this.buscarRaiosPermitidosPorEstado();
        this.buscarDadosGerais();
        this.buscarTerritorios(0);
    },

    methods: {
        editarVolume(row) {
            this.dadosEdicaoVolume = row;
            this.$refs.blocoInserirDadosContratoOriginacao.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        },
        irParaContrato() {
            this.$router.push({ name: 'Home' });
        },
        buscarDadosGerais() {
            this.carregandoDadosGerais = true;
            try {
                SucursaleService.vizualizarContrato({
                    numeroContrato: this.$route.params.numeroContrato,
                    idSucursal: this.$route.params.idSucursal
                }).then(({ data }) => {
                    this.contratoOriginacao = data;
                    this.checkRastreabilidadeOffline(this.contratoOriginacao);
                    this.volumeDisponivelContrato =
                        this.formatarToneladaToNumber(data.saldoRestante);
                });

                this.verificaConcluir();
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.erro'
                    )
                });
            }

            setTimeout(() => {
                this.carregandoDadosGerais = false;
            }, 2000);
        },
        formatarToneladaToNumber(valor) {
            return parseFloat(valor.replace(/\./g, '').replace(',', '.'));
        },
        atualizarTabela() {
            this.paginacao = {
                pagina: 0,
                total: null,
                itensPorPagina: 10
            };
            this.buscarTerritorios(this.paginacao.pagina);
            this.buscarDadosGerais();
        },
        async buscarTerritorios(pagina) {
            this.loadingTabelaCarsInseridosNoContrato = true;
            this.paginacao.pagina = pagina;

            let data = null;
            data = (
                await SucursaleService.buscarTerritoriosContrato({
                    contrato: this.$route.params.numeroContrato,
                    idSucursal: this.$route.params.idSucursal,
                    pagina: this.paginacao.pagina,
                    tamanho: this.paginacao.itensPorPagina
                })
            ).data;
            const resnpaFormatado = data.itens.map(item => ({
                ...item,
                cuit: item.territorioRepresentantes ? this.alterarMascara(
                                    item.territorioRepresentantes[0]?.cpfCnpj
                                ) : '',
                renspaTerritorio: mascaraRenspa(item.renspaTerritorio)
            }));

            this.dataTerritoriosNaoEnviados = resnpaFormatado;
            this.paginacao = { ...data.paginacao };
            this.paginacao.pagina += 1;

            this.loadingTabelaCarsInseridosNoContrato = false;
        },
        alterarMascara(cpf) {
            let novaMascara = '';

            if (cpf && cpf.length > 0) {
                const somenteNumeros = cpf.replace(/\D/g, '');
                novaMascara = somenteNumeros.replace(
                    /^(\d{2})(\d{8})(\d)$/,
                    '$1-$2-$3'
                );
            }

            return novaMascara;
        },
        async atualizarAposInserir() {
            await this.atualizarLista();
            this.conectarCanalWebsocket();
        },
        async atualizarLista() {
            this.loadingTabelaCarsInseridosNoContrato = true;
            this.paginacao = {
                pagina: 0,
                total: null,
                itensPorPagina: 10
            };
            try {
                await this.buscarTerritorios(0);
                this.buscarDadosGerais();
            } finally {
                this.loadingTabelaCarsInseridosNoContrato = false;
            }
        },
        mudarPagina(novaPagina) {
            this.buscarTerritorios(novaPagina);
        },
        ordenarTabela(column) {
            /* if (column.prop === 'subEmpresaNome') {
                    this.params.sort = 'empresaNome';
                } else {
                    this.params.sort = column.prop;
                }
    
                if (column.order === 'ascending') {
                    this.params.por = 'asc';
                } else if (column.order === 'descending') {
                    this.params.por = 'desc';
                }
                this.buscarContratosEmpresa(); */
        },
        adicionarDadosTerritorio(dadosTerritorio) {
            if (dadosTerritorio.idTerritorio) {
                const foundId = this.dataTerritoriosNaoEnviados.find(
                    element =>
                        element.idTerritorio === dadosTerritorio.idTerritorio
                );
                if (foundId) {
                    this.exibirMensagemError(
                        this.$t(
                            'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.territorioInserido'
                        )
                    );
                    return;
                }
            }

            if (dadosTerritorio.numeroCar) {
                const foundCar = this.dataTerritoriosNaoEnviados.find(
                    element => element.numeroCar === dadosTerritorio.numeroCar
                );

                if (foundCar) {
                    this.exibirMensagemError(
                        this.$t(
                            'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.territorioInserido'
                        )
                    );
                    return;
                }
            }

            this.$notify.success({
                message: dadosTerritorio.mensagemCadastroSucesso
            });

            this.$refs.tabelaTerritorio.carregarTabela(true);
            this.dataTerritoriosNaoEnviados.push(dadosTerritorio);
            this.volumeDisponivelContrato -= dadosTerritorio.volume;

            setTimeout(() => {
                this.$refs.tabelaTerritorio.carregarTabela(false);
            }, 500);
        },

        exibirMensagemError(mensagem) {
            this.$notify.error({
                message: mensagem
            });
        },

        removerTerritorioLote(territorioRemover) {
            this.territoriosSelecionados = territorioRemover;
        },

        realizarElegibilidade(territorioAnalise) {
            this.territoriosSelecionados = territorioAnalise;
        },

        realizarElegibilidadePY(territorioAnalise) {
            this.territoriosSelecionados = territorioAnalise;
        },

        reprocessarElegibilidade(territorioAnalise) {
            try {
                this.$nextTick(async () => {
                    await this.$refs.tabelaTerritorio.removerTerritoriosEmLote(
                        territorioAnalise
                    );
                    this.atualizarTabela();
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.erroRemoverTerritorio'
                    )
                });
            }
        },

        reprocessarElegibilidadePY(territorioAnalise) {
            try {
                this.$nextTick(async () => {
                    await this.$refs.tabelaTerritorio.removerTerritoriosEmLote(
                        territorioAnalise
                    );
                    this.atualizarTabela();
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.erroRemoverTerritorio'
                    )
                });
            }
        },
        async removerTerritorio() {
            if (this.territoriosSelecionados.length === 0) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.naoHaterritorios'
                    )
                );
            } else {
                await this.$messageBox.confirm(
                    this.territoriosSelecionados.length === 1
                        ? this.$t(
                              'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.confirmarRemoverTerritorio'
                          )
                        : this.$t(
                              'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.confirmarRemoverTerritorios'
                          ),
                    this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.aviso'
                    ),
                    {
                        confirmButtonText: this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.sim'
                        ),
                        cancelButtonText: this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.cancelar'
                        ),
                        type: 'warning'
                    }
                );
                try {
                    this.$nextTick(async () => {
                        await this.removerTerritoriosEmLote(
                            this.territoriosSelecionados
                        );
                        this.removerTerritorioBlocoInserirContratoUploadPlanilha(
                            this.territoriosSelecionados
                        );
                        this.atualizarTabela();
                    });
                    /* this.volumeDisponivelContrato +=
                            this.territoriosSelecionados.reduce(
                                (total, item) => total + item.volume,
                                0
                            ); */
                } catch (error) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.erroRemoverTerritorio'
                        )
                    });
                }
                // this.$notify.success(
                //    this.territoriosSelecionados.length === 1
                //        ? 'Território removido.'
                //        : 'Territórios removidos.'
                // );
            }
        },

        async removerTerritoriosEmLote(territorios) {
            for (let territorio of territorios) {
                await ContratoOriginacaoServiceSubEmpresa.removerTerritorioContratoSubEmpresaAR(
                    this.$route.params.numeroContrato,
                    territorio.idTerritorio,
                    true,
                    this.$route.params.idSucursal
                );
            }
        },

        async realizarAnalise() {
            // esse realizar saiu daqui e doi foi para o botãi de adicionar a lista
            try {
                if (this.dataTerritoriosNaoEnviados.length === 0) {
                    this.$notify.warning({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.realizarAnalise'
                        )
                    });
                    return;
                }

                this.loading = true;

                const data = this.dataTerritoriosNaoEnviados.map(territorio => {
                    return {
                        idTerritorio: territorio.idTerritorio,
                        numeroContrato: territorio.numeroContrato,
                        volume: parseFloat(territorio.volume),
                        numeroCar: territorio.numeroCar,
                        idFonte:
                            this.dadosAnaliseElegibilidade.dadosBuscaSaldo
                                .fonteDados.id,
                        idSucursal: this.$route.params.idSucursal
                    };
                });

                const response = await SucursaleService.inserirDadosContrato(
                    data
                );

                this.$notify.success({
                    message: response.data.mensagemCadastroSucesso
                });
                this.$router.push({ name: 'RastreabilidadeSucursales' });
            } catch (error) {
                this.exibirNotificacoesErros(error);
            } finally {
                this.loading = false;
            }
        },

        exibirNotificacoesErros(error) {
            if (error.response.data.type === 'MEDIA_CAPACIDADE_REGIONAL') {
                this.exibirDadosCapacidadeMediaRegional(error);
            } else {
                this.$notify.error({
                    message: error.response.data.message
                });
            }
        },

        async realizarAnaliseElegibilidade() {
            this.realizarAnaliseElegibilidadeAR();
        },

        async realizarAnaliseElegibilidadeAR() {
            try {
                if (this.territoriosSelecionados.length === 0) {
                    this.$notify.warning({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.realizarAnaliseElegibilidade'
                        )
                    });
                    return;
                }

                const data = {
                    numeroContrato: this.contratoOriginacao.numeroContrato,
                    idsTerritorios: this.territoriosSelecionados.map(
                        territorio => {
                            territorio.statusElegibilidade = 'Em processamento';
                            territorio.codigoStatusElegibilidade =
                                'EM_PROCESSAMENTO';
                            return territorio.idTerritorio;
                        }
                    ),
                    idSucursal: this.$route.params.idSucursal
                };

                this.loadingRealizarAnaliseElegibilidade = true;

                await SucursaleService.realizarAnaliseElegibilidade(data);

                this.conectarCanalWebsocket();
            } catch (error) {
                this.exibirNotificacoesErros(error);
            }
        },

        async conectarCanalWebsocket() {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.conectarWebSocket'
                    )
                });
                return;
            }

            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/contrato-originacao/subempresa/analise-concluida`,
                    response => {
                        this.loadingRealizarAnaliseElegibilidade = false;
                        this.atualizarLista();
                        disconnect();
                    }
                );
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.analiseElegibilidadePrograma'
                    )
                });
                this.loadingRealizarAnaliseElegibilidade = false;
                disconnect();
            }
        },

        async calcularRaioAR(linhaDados) {
            this.loadingResumo.loadingRaio = true;
            const dados = {
                idTerritorio: linhaDados.idTerritorio,
                numeroContrato: this.contratoOriginacao.numeroContrato,
                geometriaTerritorio: null
            };

            try {
                const response = await SucursaleService.validarRaioLocalidade(
                    dados,
                    true
                );
                this.dadosCalculoRaioAR = response.data;
            } catch (error) {
                if (
                    error.response.data.message ===
                    this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.numeroCarVegaApi'
                    )
                ) {
                    this.loadingResumo.loadingRaio = false;
                    return;
                } else {
                    this.$notify.error({
                        message: error.response.data.message
                    });
                }
            }
            this.loadingResumo.loadingRaio = false;
        },
        async validarEstado(linhaDados) {
            this.loadingResumo.loadingRaio = true;
            const dados = {
                idTerritorio: linhaDados.idTerritorio,
                numeroCar: linhaDados.resumoDiagnosticoTerritorio.imovel.codigo,
                numeroContrato: this.contratoOriginacao.numeroContrato
            };

            try {
                const response = await EstadoService.ValidarEstadoAceiteCar(
                    dados,
                    true
                );
                this.dadosAnaliseElegibilidade.dadosRestricaoEstado =
                    response.data;
            } catch (error) {
                if (
                    error.response.data.message ===
                    this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.numeroCarVegaApi'
                    )
                ) {
                    this.loadingResumo.loadingRaio = false;
                    return;
                } else {
                    this.$notify.error({
                        message: error.response.data.message
                    });
                }
            }
            this.loadingResumo.loadingRaio = false;
        },
        async buscarSaldo(linhaDados) {
            this.loadingResumo.loadingSaldo = true;
            const dados = {
                codigoCar: linhaDados.resumoDiagnosticoTerritorio.imovel.codigo,
                idTerritorio: linhaDados.idTerritorio,
                nomeMaterial: this.contratoOriginacao.materialNome,
                anoSafra: this.contratoOriginacao.safraNome,
                numeroContrato: this.contratoOriginacao.numeroContrato
            };
            try {
                const response = await SucursaleService.buscarSaldo(
                    dados,
                    true
                );
                this.dadosAnaliseElegibilidade.dadosBuscaSaldo = response.data;
            } catch (error) {
                this.$notify.error({
                    message: error.response.data.message
                });
            }
            this.loadingResumo.loadingSaldo = false;
        },
        visualizarAnaliseElegibilidade(row) {
            if (
                this.loadingResumo.loadingRaio ||
                this.loadingResumo.loadingSaldo
            ) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.modalCarregando'
                    )
                });
                return;
            }

            this.dadosAnaliseElegibilidade.safraNome =
                this.contratoOriginacao.safraNome;
            this.dadosAnaliseElegibilidade.dadosBuscaSaldo.codigoCar =
                row.territorioNome;
            this.dadosAnaliseElegibilidade.dadosBuscaSaldo.cultura.codigo =
                this.contratoOriginacao.materialNome.split(' ')[0];
            this.dadosAnaliseElegibilidade.elegibilidade =
                row.codigoStatusElegibilidade;

            this.dadosAnaliseElegibilidade.dadosDiagnostico.diagnosticoRepresentante =
                row.resumoDiagnosticoRepresentantes;
            this.dadosAnaliseElegibilidade.dadosDiagnostico.diagnosticoCar =
                row.resumoDiagnosticoTerritorio;
            this.dadosAnaliseElegibilidade.dadosDiagnostico.territorioNome =
                row.territorioNome;
            this.dadosAnaliseElegibilidade.nivelAlertaRastreabilidade =
                row.nivelAlertaRastreabilidade;
            this.calcularRaio(row);
            this.validarEstado(row);
            this.buscarSaldo(row);
            this.ativarModalAnaliseElegibilidade = true;
        },
        async visualizarAnaliseElegibilidadePY(row) {
            if (
                this.loadingResumo.loadingRaio ||
                this.loadingResumo.loadingSaldo
            ) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.modalCarregando'
                    )
                });
                return;
            }

            this.dadosDetalheAnaliseElegibilidadePY = row;

            await this.calcularRaioPY(row);
            this.ativarModalAnaliseElegibilidade = true;
        },
        async visualizarAnaliseElegibilidadeAR(row) {
            try {
                const numeroContrato = this.$route.params.numeroContrato;
                const idTerritorio = row.idTerritorio;
                const idSucursal = this.$route.params.idSucursal;
                const { data } = await ContratoOriginacaoServiceSubEmpresa.buscarResumoAnaliseElegibilidadePreInsercaoTerritorioAr({
                    idRepresentante: 0,
                    idTerritorio: idTerritorio,
                    numeroContrato: numeroContrato,
                    isSucursal: true,
                    idDadosContratoOriginacao: row.id,
                    idSucursal: idSucursal
                });

                // Mapear dados para estrutura unificada
                this.dadosAnaliseElegibilidade.dadosDiagnostico = data.diagnosticoSocioambiental;
                this.dadosAnaliseElegibilidade.dadosCalculoRaio = data.raioTerritorio;
                this.dadosAnaliseElegibilidade.elegibilidade = data.resultadoResumoAnaliseElegibilidadePreInsercaoTerritorioSubempresa;
                this.dadosAnaliseElegibilidade.saldoTerritorial = data.diagnosticoSaldoTerritorial;
                this.dadosAnaliseElegibilidade.territorioOutput = data.territorioOutput;
                this.dadosAnaliseElegibilidade.certificacao = data.certificacao;

                this.ativarModalAnaliseElegibilidade = true;
            } catch (e) {
                if (
                    e.response?.data?.message ===
                    'rendimento.provinciaEDepartamentoNaoEncontrado'
                ) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.erroRendimento'
                        )
                    });
                    return;
                }

                this.$notify.error({
                    message: e.response?.data?.message
                });
            }
        },
        visualizarContratoSucursal() {
            const contrato = this.contratoOriginacao.numeroContrato
                ? this.contratoOriginacao.numeroContrato
                : this.$router.params.numeroContrato;
            this.$router.push({
                name: 'VizualizarContratoSucursales',
                params: { numeroContrato: contrato, idSucursal: this.$route.params.idSucursal }
            });
        },
        async buscarRaiosPermitidosPorEstado() {
            const { data } =
                await RaioPermitidoPorEstadoRastreabilidadeService.findAll();
            this.raiosPermitidosPorEstado = data;
        },
        removerTerritorioBlocoInserirContratoUploadPlanilha(
            territoriosSelecionados
        ) {
            if (this.$refs.blocoDadosContratoUpload) {
                this.$refs.blocoDadosContratoUpload.removerTerritorioBlocoInserirContratoUploadPlanilha(
                    territoriosSelecionados
                );
            }
        },
        checkRastreabilidadeOffline(contrato) {
            if (contrato.tipoContratoOffline && this.usuarioLogado.isBunge) {
                this.isRastreabilidadeOffline = true;
            }
        },
        async verificaConcluir() {
            this.mensagemValidacaoConcluir = [];
            try {
                const { data } =
                    await SucursaleService.verificaSePodeConcluirOContrato(
                        this.$route.params.numeroContrato,
                        this.$route.params.idSucursal
                    );

                this.botaoConcluirHabilitado = data.podeConcluir;

                this.mensagemValidacaoConcluir = data.avisos;

                if (this.foiConcluido) {
                    this.botaoConcluirHabilitado = false;
                } else {
                    this.conectarCanalWebsocket();
                }
            } catch (error) {
                this.mensagemValidacaoConcluir = [];

                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.contratoConcluido'
                    )
                });
            }
        }
    }
};
</script>

<style lang="scss">
#preencher-contrato-originacao {
    .bloco-dados-contrato-originacao,
    .bloco-inserir-dados-contrato-originacao,
    .bloco-listagem-territorio-contrato,
    .bloco-view-container-down {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
    }

    .bloco-inserir-dados-contrato-originacao {
        gap: 15px;
        width: 100%;
        margin-top: 20px;

        .el-card__body {
            align-items: stretch;
        }
    }

    .bloco-dados-contrato-originacao {
        justify-content: space-between;
        gap: 4px;

        .el-card__body {
            align-items: stretch;
        }
    }

    .bloco-view-container-down {
        gap: 15px;
        width: 100%;
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;

        .bloco-view-container-down__conteudo__remove-item {
            el-link {
                color: var(--hover-danger);
            }
        }

        .bloco-view-container-down__conteudo__buttons {
            display: flex;
            gap: 10px;
        }
    }

    footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 16px;

        .botao-territorio__remover {
            margin-top: 16px;

            .lyra-icon.lyra-grafico ::after {
                color: white;
            }

            #adicionar-analise {
                span {
                    margin-left: 5px;
                }
            }
        }

        .botao-territorio__enviar-para-analise {
            display: flex;
            align-items: center;

            .el-button {
                border-color: var(--primary);
                background: none;
                color: var(--primary);
            }

            .el-button.is-plain:hover,
            .el-button.is-plain:focus {
                background: var(--color-button-default-hover);
                border-color: var(--primary);
                color: var(--primary);
            }

            .lyra-icon.lyra-grafico ::after {
                color: var(--primary);
            }

            .el-button.button-outline {
                font-weight: bold;
            }

            #adicionar-analise {
                display: flex;
                align-items: center;

                span {
                    margin-left: 5px;
                }
            }

            i.el-icon-view {
                font-size: 18px;
            }
        }
    }

    .bloco-infor {
        margin-top: 20px;

        .el-alert__title {
            color: #3b3b3b !important;
        }
    }

    .bloco-infor {
        margin-top: 20px;

        .el-alert__title {
            color: #3b3b3b !important;
        }
    }

    .warning-cars {
        margin-top: 10px !important;
    }
}
</style>
